/* eslint-disable @next/next/no-img-element */
import { StyledExploreAndPlay } from './ExploreAndPlay.styled';

export default function ExploreAndPlay({ className, disabled }) {
  return (
    <StyledExploreAndPlay className={className} disabled={disabled}>
      <span style={{ whiteSpace: 'nowrap' }}>
        <span>Student</span> <span>L</span>
        <span>i</span>
        <span>b</span>
        <span>r</span>
        <span>a</span>
        <span>r</span>
        <span>y</span>
      </span>
    </StyledExploreAndPlay>
  );
}
